import React, {Component} from 'react'
import {Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import UserRolesTable from "./UserRolesTable"
import UserRoleCreate from './UserRoleCreate'
import {checkPermission, CAN_CREATE_USER_ROLES} from "../../../lib/permissions";

export default class UserRolesNew extends Component {

    state = {
        createOpen: false
    }

    toggleCreate = () => {
        this.setState({createOpen: !this.state.createOpen})
    }

    render() {

        const {createOpen} = this.state

        return (
            <div className="d-flex flex-column">
                <div className="d-flex flex-row align-items-center justify-content-end p-3">
                    {checkPermission(CAN_CREATE_USER_ROLES) &&
                    <Button
                        size="sm"
                        color="success"
                        onClick={this.toggleCreate}
                    >
                        <FontAwesomeIcon
                            color="#fff"
                            icon="plus"/>{' '}
                        Add User Role
                    </Button>}
                </div>
                <UserRolesTable/>
                <UserRoleCreate
                    isOpen={createOpen}
                    toggle={this.toggleCreate}
                />
            </div>
        )

    }

}